import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../Constants";
import {
    aiMhFetchSubDetails,
    aiMhHandlePopupOpen,
    aiMhUpdatePageType,
    aiMhUpdateSubDetails,
    resetAiMhLandingPage,
} from "../../store/AiMarketingHub/AimhLandingPage/AimhLpReducer";
import { httpRequest } from "../../utils/networkCalls";
import CouponPopups from "../Form/Utilities/Coupons";
import { FORM_SCHEMA } from "../../Constants";
import { applyCoupon, redirectToOrderSummary } from "../Form/Utilities";
import { useHistory } from "react-router-dom";
import Payments from "../Form/Payments";
import Success from "../Form/Success";
import { updateLoadingStatus } from "../../store/Loader/LoaderReducer";
import Loader from "../Utilities/Loader";
import { showToastMessage, useQuery } from "../../utils/common";
import {
    AgentsBioIcon,
    CircleCheckIcon,
    CircleCloseIcon,
    ExhaustedFtDigitalFlyersIcon,
    ExhaustedFtMarketingEmailIcon,
    ExhaustedFtPropDesIcon,
    ExhaustedFtPropDescIcon,
    ExhaustedFtPropVideoIcon,
    ExhaustedFtRewriteContIcon,
    ExhaustedFtSocialMediaIcon,
    LockIconDisabled,
    RightArrowIcon,
} from "./components/Assets/Icons";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "8px",
        padding: "0px",
        maxHeight: window.screen.width < 767 && "70vh",
        overflowY: window.screen.width < 767 && "auto",
    },
    overlay: { background: "rgb(0,0,0,0.25)" },
};

export const aiMhIsActives = [
    "Ai Marketinghub",
    "Property Description",
    "Marketing Emails",
    "Social Media Captions",
    "History",
    "Rewrite Content",
    "Property Videos",
    "Flyers",
    "Property Videos Form",
    "Agent's Bio",
];

// const dummyFormSchema = {
//     logs: {
//         order_source: "website",
//     },
//     images_list: [
//         {
//             url: "https://styldodassets.s3.us-west-2.amazonaws.com/staging_images/167463881844772/image/1674638832505714921_screenshot_2023_01_25_at_11_50_32_am.png",
//             name: "staging_images/167463881844772/image/1674638832505714921_screenshot_2023_01_25_at_11_50_32_am.png",
//         },
//     ],
//     image_details: [
//         {
//             image: "https://styldodassets.s3.us-west-2.amazonaws.com/staging_images/167463881844772/image/1674638832505714921_screenshot_2023_01_25_at_11_50_32_am.png",
//             room: "NA",
//             furniture: "",
//             info: "",
//             basic_editing: "false",
//             clutter_removal: "false",
//             occupied_to_vacant: "false",
//             image_modification: "false",
//             pool_lights: "true",
//             turn_lights_on: "false",
//             fire_to_fireplace: "false",
//             sky_replace: "false",
//             sky_color: "",
//         },
//     ],
//     floorplan: [],
//     videos_list: [],
//     reference_images: [],
//     is3dPhotos: "",
//     isRapidDelivery: "NO",
//     rapidTime: "NO",
//     isFreeTrial: "NO",
//     stype: "day_to_dusk",
//     version: "v4",
//     isNotified: false,
//     orderID: "",
//     __v: 0,
//     add_ons: {
//         property_website: "false",
//         project_video: "false",
//     },
//     comment: "",
//     email: "naveen.bandela@styldod.com",
//     event: "",
//     gcid: "",
//     links: "",
//     name: "Naveen Bandela",
//     number_of_img: "1",
//     phone: "",
//     project_name: "Project #167463881844772",
//     status: "draft",
//     style: "None",
// };

const AiMhPaymentPopup = ({
    formSchema,
    setCouponDis,
    couponDis,
    setErrMssge,
    setIsError,
    setIsCpnApplied,
    setPrice,
    setCoupon,
    isCpnApplied,
    coupon,
    setIsTerm,
    isTerm,
    price,
    setShowCouPopup,
    paymentPopup,
}) => {
    const dispatch = useDispatch();

    const handleMakePayment = () => {
        if (isTerm) {
            dispatch(aiMhUpdatePageType({ pgType: "payments" }));
        } else {
            showToastMessage({
                icon: "error",
                mssge: "Please accept terms and conditions",
                time: 3000,
            });
        }
    };

    const items = [
        "Unlimited property descriptions",
        "Unlimited property videos",
        "Access to all video templates",
        "Unlimited digital flyers",
        "Access to all flyer templates",
        "Unlimited social media captions",
        "Unlimited marketing emails",
        "Rewrite unlimited contents",
    ];

    return (
        <ReactModal
            isOpen={paymentPopup.isVisible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() =>
                dispatch(
                    aiMhHandlePopupOpen({
                        type: "paymentPopup",
                        isVisible: false,
                    })
                )
            }
        >
            <div className="ud-aimh-pp-2">
                <div className="ud-aimh-pp-title">AI Marketing Hub</div>
                <div className="ud-aimh-pp-desc">
                    Create engaging assets and content for listing promotion.
                    Save time. Save money. Grow professionally.
                </div>
                <div className="ud-aimh-pp-main-cont">
                    <div className="ud-aimh-pp-bnft-cont">
                        <div className="ud-aimh-pp-bnft-cont-title">
                            Benefits
                        </div>
                        <div className="ud-aimh-pp-bnft-items-cont">
                            {items.map((item, i) => (
                                <div key={i} className="ud-aimh-pp-bnft-item">
                                    <div className="ud-aimh-pp-bnft-item-icon">
                                        <CircleCheckIcon />
                                    </div>
                                    <div className="ud-aimh-pp-bnft-item-desc">
                                        {item}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* <div id="ordSum" className="ud-vid-orsum-cont av"> */}
                    <div className="ud-aimh-pp-pymt-cont-2">
                        <div className="ud-orsum-header">
                            ORDER&nbsp;SUMMARY
                        </div>
                        <div className="ud-summary-list">
                            <div className="ud-summary-item">
                                <span className="ud-summary-name">
                                    AI Marketing Hub Subscription
                                </span>{" "}
                                {/* for 0 photos */}
                                <span className="ud-summary-amount">
                                    {"$" + price.totalAmount}
                                </span>
                            </div>
                        </div>
                        <div className="ud-summary-total w-clearfix">
                            SUB TOTAL{" "}
                            <span className="ud-total-amount">
                                {"$" + price.totalAmount}
                            </span>
                        </div>

                        {isCpnApplied ? (
                            <>
                                <div className="ud-summary-list">
                                    <div className="ud-summary-item rm-mar">
                                        Coupon {coupon}
                                        <span className="ud-summary-amount">
                                            {"$" + price.totalAmount}
                                        </span>
                                    </div>
                                </div>
                                <div className="ud-os-coupon-sec">
                                    <div className="ud-os-vc weight">
                                        View coupon codes
                                    </div>
                                    <div
                                        onClick={() => {
                                            applyCoupon(
                                                formSchema,
                                                setCouponDis,
                                                couponDis,
                                                setErrMssge,
                                                setIsError,
                                                setIsCpnApplied,
                                                isCpnApplied,
                                                price,
                                                setPrice,
                                                coupon,
                                                setCoupon
                                            );
                                        }}
                                        className="ud-os-cc-lbel rm-cc"
                                    >
                                        Remove
                                    </div>
                                </div>
                            </>
                        ) : (
                            <></>
                            // <div className="ud-os-coupon-sec">
                            //     <div className="ud-os-cc-lbl">
                            //         <img
                            //             loading="lazy"
                            //             src="https://assets.website-files.com/60d5e32a2e61d222f79c6145/60ddad45dd1ecca28f2a02a6_discount-badge.png"
                            //             alt=""
                            //             className="ud-ccpb"
                            //         />
                            //         <div className="ud-os-cc-lbel">
                            //             Select coupon code
                            //         </div>
                            //     </div>
                            //     <div
                            //         onClick={() => setShowCouPopup(true)}
                            //         className="ud-os-vc"
                            //     >
                            //         View coupons
                            //     </div>
                            // </div>
                        )}
                        <div className="ud-summary-total w-clearfix">
                            ORDER TOTAL{" "}
                            <span className="ud-total-amount bold-price">
                                {"$" + price.totalAmount}
                            </span>
                        </div>
                        <div style={{ height: "50px" }}></div>
                        <a
                            onClick={handleMakePayment}
                            // href="#"
                            className="action-btn-2 prestepa os-btn w-button"
                            style={{ marginBottom: "unset" }}
                        >
                            Make payment
                        </a>
                        <label className="w-checkbox ud-tnc-chk os-tc">
                            <div
                                className={
                                    isTerm
                                        ? "w-checkbox-input w-checkbox-input--inputType-custom ud-chk w--redirected-checked"
                                        : "w-checkbox-input w-checkbox-input--inputType-custom ud-chk"
                                }
                            ></div>
                            <input
                                type="checkbox"
                                name="checkbox-9"
                                style={{
                                    opacity: 0,
                                    position: "absolute",
                                    zIndex: -1,
                                }}
                                onClick={() => {
                                    setIsTerm(!isTerm);
                                }}
                            />
                            <span
                                className="ud-tnc-label-2 os-tc w-form-label"
                                htmlFor="checkbox-9"
                            >
                                I agree to the{" "}
                                <a
                                    href="https://dollardesigndimela.webflow.io/terms"
                                    target={"_blank"}
                                    className="ud-tnc-link"
                                >
                                    terms and conditions.
                                </a>
                            </span>
                        </label>
                    </div>
                    {/* <div className="ud-checkout-cont">
                            <div className="ud-checkout-txt">
                                Payments secured by
                            </div>
                            <img
                                loading="lazy"
                                src="https://assets.website-files.com/60d5e32a2e61d222f79c6145/60dda53c2f0d9e4e7352fc73_stripe-pp.png"
                                alt=""
                                className="ud-checkout-image"
                            />
                        </div> */}
                    {/* </div> */}
                </div>
                <div
                    onClick={() =>
                        dispatch(
                            aiMhHandlePopupOpen({
                                type: "paymentPopup",
                                isVisible: false,
                            })
                        )
                    }
                    className="ud-aimh-pp-close-icon"
                >
                    <CircleCloseIcon />
                </div>
            </div>
        </ReactModal>
    );
};

const AimhExhaustedFeaturesPopup = ({ handleClickSubscribe, eftPopup }) => {
    const dispatch = useDispatch();
    return (
        <ReactModal
            isOpen={eftPopup?.isVisible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() =>
                dispatch(
                    aiMhHandlePopupOpen({ type: "eftPopup", isVisible: false })
                )
            }
        >
            {/* <div className="ud-aimh-eft-popup"> */}

            <div className="ud-aimh-eft-popup-info-cont-2">
                <div className="ud-aimh-eft-popup-title-2">
                    You have exhausted the free trial
                </div>
                <div
                    onClick={() =>
                        dispatch(
                            aiMhHandlePopupOpen({
                                type: "eftPopup",
                                isVisible: false,
                            })
                        )
                    }
                    className="ud-aimh-eft-popup-close-icon-2"
                >
                    <CircleCloseIcon />
                </div>
                <div className="ud-aimh-eft-popup-info-cont-title-2">
                    Access to UNLIMITED benefits
                </div>
                <div className="ud-aimh-eft-popup-info-items-cont-2">
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <ExhaustedFtPropDesIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Property Description
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <ExhaustedFtSocialMediaIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Social Media Captions
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <ExhaustedFtMarketingEmailIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Marketing Emails
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <ExhaustedFtRewriteContIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Rewrite Content
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <ExhaustedFtPropVideoIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Real estate Property Videos
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <ExhaustedFtDigitalFlyersIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Real estate Flyers
                        </div>
                    </div>
                    {window.screen.width > 767 &&<div className="ud-aimh-eft-popup-info-item">
                        {/* <div className="ud-aimh-eft-popup-info-item-icon">
                            <AgentsBioIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Agent's Bio
                        </div> */}
                    </div>}
                    <div className="ud-aimh-eft-popup-info-item">
                        <div className="ud-aimh-eft-popup-info-item-icon">
                            <AgentsBioIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-item-title-2">
                            Agent's Bio
                        </div>
                    </div>
                </div>
                <div className="ud-aimh-eft-popup-info-btn-cont">
                    <div
                        onClick={handleClickSubscribe}
                        className="ud-aimh-eft-popup-info-btn"
                    >
                        Subscribe
                    </div>
                </div>
                <div className="ud-aimh-eft-popup-info-bnft-cont-2">
                    <div className="ud-aimh-eft-popup-info-bnft-item">
                        <div className="ud-aimh-eft-popup-info-bnft-item-icon">
                            <CircleCheckIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-bnft-item-desc-2">
                            Unlimited generations
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-bnft-item">
                        <div className="ud-aimh-eft-popup-info-bnft-item-icon">
                            <CircleCheckIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-bnft-item-desc-2">
                            Unlimited templates
                        </div>
                    </div>
                    <div className="ud-aimh-eft-popup-info-bnft-item">
                        <div className="ud-aimh-eft-popup-info-bnft-item-icon">
                            <CircleCheckIcon />
                        </div>
                        <div className="ud-aimh-eft-popup-info-bnft-item-desc-2">
                            No watermark
                        </div>
                    </div>
                </div>
                <div className="ud-aimh-eft-popup-info-cont-gd1"></div>
                <div className="ud-aimh-eft-popup-info-cont-gd2"></div>
            </div>
            {/* </div> */}
        </ReactModal>
    );
};

export const AimhCardsContainer = ({ userDetails }) => {
    const aiMhLpState = useSelector((state) => state.AimhLpReducer);
    const aimhFormSchema = aiMhLpState.formSchema
    const [formSchema, setFormSchema] = useState({
        ...aimhFormSchema,
        email: userDetails?.email,
        name: userDetails?.name,
    });
    const history = useHistory();
    const query = useQuery();
    const qsOid = query.get("order-id");
    const dispatch = useDispatch();

    const handleClickSubscribe = async () => {
        try{
        // Show Loader here
        history.push('/ai-marketinghub')
        dispatch(updateLoadingStatus(true));

        const tempRes = await httpRequest(`temp_order`, "post", formSchema);
        const stagingRes = await httpRequest(
            `staging/submit-order-v2`,
            "post",
            { oid: formSchema.orderID }
        );

        dispatch(
            aiMhHandlePopupOpen({
                type: "paymentPopup",
                isVisible: true,
            })
        );

        // Hide Loader here
        dispatch(updateLoadingStatus(false));
    }
    catch(err){
        if (err?.response?.status == '400' && qsOid) {
            redirectToOrderSummary(history,qsOid);
        }
    }
    };

    return (
        <div className="ud-aimh-lp-cards-cont-wrapper-2">
            <div
                className={
                    aiMhLpState?.subDetails?.is_subscribed
                        ? "ud-aimh-lp-cards-cont-2 paid"
                        : "ud-aimh-lp-cards-cont-2"
                }
            >
                {Object.keys(aiMhLpState?.cards).map((cardKey, i) => {
                    let cardObj = aiMhLpState?.cards[cardKey];

                    return (
                        <div
                            onClick={() => {
                                if (cardObj?.isDiabled) {
                                    handleClickSubscribe();
                                } else {
                                    cardObj?.isOpenInNewTab
                                        ? window.open(cardObj?.url)
                                        : history.push({
                                              pathname: `${cardObj?.url}`,
                                              stype: `${
                                                  cardObj?.stype &&
                                                  cardObj?.stype
                                              }`,
                                          });
                                }
                            }}
                            key={i}
                            className={
                                cardObj?.isDiabled
                                    ? "ud-aimh-lp-card-2 disabled"
                                    : "ud-aimh-lp-card-2"
                            }
                        >
                            <div className="ud-aimh-lp-card-icon-cont">
                                <div className="ud-aimh-lp-card-icon">
                                    {cardObj?.isDiabled
                                        ? cardObj?.disabled?.icon
                                        : cardObj?.icon}
                                </div>
                                {aiMhLpState?.subDetails?.is_subscribed || (
                                    <div
                                        className={
                                            cardObj?.isDiabled
                                                ? "ud-aimh-lp-card-tag disabled"
                                                : "ud-aimh-lp-card-tag"
                                        }
                                    >
                                        {cardObj?.isDiabled
                                            ? cardObj?.disabled?.tag
                                            : cardObj?.tag}
                                    </div>
                                )}
                            </div>
                            <div className="ud-aimh-lp-card-title">
                                {cardObj?.title}
                            </div>
                            <div className="ud-aimh-lp-card-desc">
                                {cardObj?.description}
                            </div>
                            <div className="ud-aimh-lp-card-action-cont-wrap">
                                <div
                                    // onClick={() => {
                                    //     cardObj?.isOpenInNewTab
                                    //         ? window.open(
                                    //               cardObj?.url
                                    //           )
                                    //         : history.push(
                                    //               `${cardObj?.url}${cardObj?.stype?"?stype="+cardObj?.stype:""}`
                                    //           );
                                    // }}
                                    className="ud-aimh-lp-card-action-cont"
                                >
                                    <div className="ud-aimh-lp-card-action-title">
                                        {cardObj?.isDiabled
                                            ? "Subscribe"
                                            : aiMhLpState?.subDetails
                                                  ?.is_subscribed
                                            ? "Start now"
                                            : cardObj?.actionName}
                                    </div>

                                    <div className="ud-aimh-lp-card-action-icon">
                                        <RightArrowIcon />
                                    </div>
                                </div>
                                {cardObj?.isDiabled && (
                                    <div className="ud-aimh-lp-card-action-lock-icon">
                                        <LockIconDisabled />
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            {aiMhLpState?.subDetails?.is_subscribed || (
                <div className="ud-aimh-lp-price-card-2">
                    <div className="ud-aimh-lp-price-card-title-2">
                        {aiMhLpState["subscribeCard"]["title"]}
                    </div>
                    <div className="ud-aimh-lp-price-card-info-cont-2">
                        <div className="ud-aimh-lp-price-card-priceinfo-cont-2">
                            <div className="ud-aimh-lp-price-card-priceinfo">
                                <div className="ud-aimh-lp-price-card-priceinfo-currency-2">
                                    $
                                    <span className="ud-aimh-lp-strike_through-txt">
                                        {
                                            aiMhLpState["subscribeCard"][
                                                "actualPrice"
                                            ]["monthly"]
                                        }
                                    </span>
                                </div>
                                <div className="ud-aimh-lp-price-card-priceinfo-val-2">
                                    $
                                    {
                                        aiMhLpState["subscribeCard"][
                                            "discountedPrice"
                                        ]["monthly"]
                                    }
                                </div>
                                <div className="ud-aimh-lp-price-card-priceinfo-desc">
                                    per month
                                </div>
                            </div>
                            <div className="ud-aimh-lp-price-card-priceinfo-annual-desc">
                                Billed annually at $
                                <span className="ud-aimh-lp-strike_through-txt">
                                    {
                                        aiMhLpState["subscribeCard"][
                                            "actualPrice"
                                        ]["yearly"]
                                    }
                                </span>{" "}
                                $
                                {
                                    aiMhLpState["subscribeCard"][
                                        "discountedPrice"
                                    ]["yearly"]
                                }
                            </div>
                        </div>

                        <div className="ud-aimh-lp-price-card-bnftinfo-cont-2">
                            {aiMhLpState["subscribeCard"]["benefits"].map(
                                (bnft, i) => {
                                    return (
                                        <div
                                            key={i}
                                            className="ud-aimh-lp-price-card-bnftinfo-item"
                                        >
                                            <div className="ud-aimh-lp-price-card-bnftinfo-item-icon">
                                                <CircleCheckIcon />
                                            </div>
                                            <div className="ud-aimh-lp-price-card-bnftinfo-item-desc">
                                                {bnft}
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </div>
                    <div className="ud-aimh-lp-price-card-btn-cont">
                        <div
                            onClick={handleClickSubscribe}
                            className="ud-aimh-lp-price-card-btn"
                        >
                            Upgrade now
                        </div>
                    </div>
                    <div className="ud-aimh-lp-price-card-circle1"></div>
                    <div className="ud-aimh-lp-price-card-circle2"></div>
                    <div className="ud-aimh-lp-price-card-disct-strap-2">
                        {aiMhLpState["subscribeCard"]["percentageDiscount"]} OFF
                    </div>
                </div>
            )}
        </div>
    );
};

function AiMarketingHub({ setIsActive, setPbStep, userDetails }) {
    const history = useHistory();
    const [isLoaded, setIsLoaded] = useState(true);
    const aiMhLpState = useSelector((state) => state.AimhLpReducer);
    const loaderState = useSelector((state) => state.LoaderReducer);
    const dispatch = useDispatch();
    const aimhFormSchema = aiMhLpState.formSchema
    const [formSchema, setFormSchema] = useState({
        ...aimhFormSchema,
        email: userDetails?.email,
        name: userDetails?.name,
    });
    const [price, setPrice] = useState({ totalAmount: 144 });
    const [isError, setIsError] = useState(false);
    const [errMssge, setErrMssge] = useState("");
    const [showCouPopup, setShowCouPopup] = useState(false);
    const [coupon, setCoupon] = useState("");
    const [isCpnApplied, setIsCpnApplied] = useState(false);
    const [couponDis, setCouponDis] = useState(0);
    const [proCoupon, setProCoupon] = useState([]);
    const [isTerm, setIsTerm] = useState(true);
    const query = useQuery();
    const qsOid = query.get("order-id");

    useEffect(() => {
        dispatch(aiMhFetchSubDetails({ userDetails: userDetails }));
        return () => {
            dispatch(resetAiMhLandingPage());
        };
    }, []);

    const handleClickSubscribe = async () => {
        // Show Loader here
        try{
        dispatch(updateLoadingStatus(true));

        const tempRes = await httpRequest(`temp_order`, "post", formSchema);
        const stagingRes = await httpRequest(
            `staging/submit-order-v2`,
            "post",
            { oid: formSchema.orderID }
        );

        dispatch(
            aiMhHandlePopupOpen({
                type: "paymentPopup",
                isVisible: true,
            })
        );

        // Hide Loader here
        dispatch(updateLoadingStatus(false));
    }
    catch(err){
    if (err?.response?.status == '400' && qsOid) {
        redirectToOrderSummary(history,qsOid);
    }
}
    };

    const handleChangePage = (type) => {
        dispatch(aiMhUpdatePageType({ pgType: type }));
    };

    return (
        <>
            {loaderState["isLoading"] ? (
                <div className="ud-mask-container">
                    <Loader type={"spin"} color={"#a6df50"} />
                </div>
            ) : (
                <>
                    {aiMhLpState.pageType === "home" && (
                        <div className="ud-aimh-lp wf-section">
                            <div className="ud-aimh-lp-title-cont">
                                <div className="ud-aimh-lp-title-heading">
                                    AI Marketing Hub
                                </div>
                                <div className="ud-aimh-lp-title-desc">
                                    {aiMhLpState?.subDetails?.is_subscribed
                                        ? "(Paid plan)"
                                        : "(Free plan)"}
                                </div>

                                {aiMhLpState?.subDetails?.is_subscribed || (
                                    <div
                                        onClick={handleClickSubscribe}
                                        className="ud-aimh-lp-price-card-btn"
                                    >
                                        Upgrade now
                                    </div>
                                )}
                            </div>
                            <div className="ud-aimh-lp-subtitle">
                                Create promotional materials and content for
                                your listings in seconds.
                            </div>
                            <AimhCardsContainer userDetails={userDetails}/>
                            <AiMhPaymentPopup
                                formSchema={formSchema}
                                setCouponDis={setCouponDis}
                                couponDis={couponDis}
                                setErrMssge={setErrMssge}
                                setIsError={setErrMssge}
                                setIsCpnApplied={setIsCpnApplied}
                                setPrice={setPrice}
                                setCoupon={setCoupon}
                                isCpnApplied={isCpnApplied}
                                coupon={coupon}
                                setIsTerm={setIsTerm}
                                isTerm={isTerm}
                                price={price}
                                setShowCouPopup={setShowCouPopup}
                                paymentPopup={aiMhLpState?.popUps?.paymentPopup}
                            />
                            <AimhExhaustedFeaturesPopup
                                handleClickSubscribe={handleClickSubscribe}
                                eftPopup={aiMhLpState?.popUps?.eftPopup}
                            />
                            <CouponPopups
                                showCouPopup={showCouPopup}
                                setShowCouPopup={setShowCouPopup}
                                formSchema={formSchema}
                                setCouponDis={setCouponDis}
                                couponDis={couponDis}
                                setErrMssge={setErrMssge}
                                setIsError={setIsError}
                                setIsCpnApplied={setIsCpnApplied}
                                isCpnApplied={isCpnApplied}
                                price={price}
                                setPrice={setPrice}
                                coupon={coupon}
                                setCoupon={setCoupon}
                                userDetails={userDetails}
                                proCoupon={proCoupon}
                            />
                        </div>
                    )}
                    {aiMhLpState.pageType === "payments" && (
                        <div className="ud-aimh-lp wf-section">
                            <div
                                className="ud-upld-photos"
                                style={{ textAlign: "center" }}
                            >
                                <div className="w-row">
                                    <div className="ud-form-heading-cont w-col w-col-12">
                                        <h2 className="ud-form-heading">
                                            <span
                                                className="ud-form-back"
                                                onClick={() =>
                                                    handleChangePage("home")
                                                }
                                                style={{ float: "left" }}
                                            >
                                                
                                            </span>
                                            AI Marketing Hub
                                            <div
                                                className="ud-mp-oid"
                                                style={{ fontSize: "18px" }}
                                            >
                                                (Order ID: {formSchema.orderID})
                                            </div>
                                        </h2>
                                    </div>
                                </div>
                                <div
                                    className="ud-form-top-txt"
                                    style={{ margin: "auto" }}
                                >
                                    Everything is set to go! Just finalize your
                                    payment and your subscription will be
                                    activated!
                                </div>
                            </div>
                            <Payments
                                price={price}
                                setPrice={setPrice}
                                coupon={coupon}
                                isCpnApplied={isCpnApplied}
                                setIsCpnApplied={setIsCpnApplied}
                                couponDis={couponDis}
                                setCouponDis={setCouponDis}
                                formSchema={formSchema}
                                stype={formSchema.stype}
                                setCurrentStep={handleChangePage}
                                setPbStep={setPbStep}
                                setIsError={setIsError}
                                setErrMssge={setErrMssge}
                                isLoaded={isLoaded}
                                setIsLoaded={setIsLoaded}
                            />
                        </div>
                    )}
                    {aiMhLpState.pageType === "successful" && (
                        <Success
                            propStype={formSchema.stype}
                            userDetails={userDetails}
                            setIsActive={setIsActive}
                        />
                    )}
                </>
            )}
        </>
    );
}

export default AiMarketingHub;
